import React from 'react'

const EMPTY = "/images/empty.gif"

export default function CardGif ({ gif }) {
  return (
    <div className="gif-picker__gif" style={{ backgroundImage: `url(${ gif || EMPTY })` }} />
  )
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/card-gif.jsx
 **/